var map = {
	"./aprovavp/white-logo.svg": 77820,
	"./backupDemo/white-logo.svg": 66968,
	"./brasilstartups/white-logo.svg": 7502,
	"./canaleducacao/white-logo.svg": 40797,
	"./egepi/white-logo.svg": 5955,
	"./fic/white-logo.svg": 56790,
	"./iesb/white-logo.svg": 66038,
	"./inkluziva/white-logo.svg": 70028,
	"./maiseducacao/white-logo.svg": 67890,
	"./oab/white-logo.svg": 79597,
	"./oros/white-logo.svg": 8454,
	"./powerforgirls/white-logo.svg": 24500,
	"./quartosecretariado/white-logo.svg": 23861,
	"./retina/white-logo.svg": 98721,
	"./seducpi/white-logo.svg": 36768,
	"./sett-solutions/white-logo.svg": 79024,
	"./siape/white-logo.svg": 56103,
	"./tjpara/white-logo.svg": 44137,
	"./unisescoop/white-logo.svg": 38663,
	"./vegalabs/white-logo.svg": 96872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20481;